export const DLayoutDirection = wcardinal.ui.DLayoutDirection;